import { PayPalButtonOnCancel } from "@paypal/paypal-js"
import { setExpressCheckoutActive, setExpressCheckoutErrorMessage } from "src/checkout/state/checkoutExpressStore"
import { paypalLogPrefix } from "src/integrations/paypal/constants"

export const payPalButtonOnCancel: PayPalButtonOnCancel = async (data, actions) => {
  console.debug(paypalLogPrefix, "onCancel", data, actions)
  setExpressCheckoutErrorMessage("Der Checkout mit PayPal wurde abgebrochen.")
  setExpressCheckoutActive(false)
}
